

// Removes explicitly undefined field values from an object or array of objects, assuming they are optional fields.
// This helps prevent undefined values being converted to null in the database, which may not match the schema.
export function removeUndefined<T>(obj: T): T {
    if (Array.isArray(obj)) {
        return obj.map(it => removeUndefined(it)) as unknown as T;
    }

    if (isPlainObject(obj)) {
        return Object.fromEntries(
            Object.entries(obj)
                .filter(([_, v]) => v !== undefined)
                .map(([k, v]) => [k, removeUndefined(v)])
        ) as unknown as T;
    }
    return obj;
}

// Helps avoid trying to clean Date and ObjectId types, which would become broken.
function isPlainObject(value: unknown): value is Record<string, unknown> {
    return (
        typeof value === 'object' &&
        value !== null &&
        Object.getPrototypeOf(value) === Object.prototype
    );
}
